import { categories } from '@/mocks/categories';

export default function CategoriesGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">Categories</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950">
            Popular AllChinaBuy Spreadsheet Categories
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 md:gap-4 max-w-6xl mx-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden bg-white border border-background-200 hover:border-primary-300 hover:shadow-lg transition-all aspect-[4/5]"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <p className="text-sm md:text-base font-semibold text-white group-hover:text-primary-300 transition-colors">
                  {cat.name}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* Row of buttons as alternative */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-2 max-w-4xl mx-auto">
          {categories.slice(0, 7).map((cat) => (
            <a
              key={`btn-${cat.name}`}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 bg-white text-sm font-medium text-foreground-700 rounded-lg border border-background-200 hover:border-primary-400 hover:text-primary-600 hover:shadow-sm transition-all whitespace-nowrap"
            >
              {cat.name}
            </a>
          ))}
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-5 py-2.5 bg-primary-500 text-sm font-medium text-white rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            AllChinaBuy Spreadsheet
          </a>
        </div>
      </div>
    </section>
  );
}